import React from 'react';
import {
  CourseNameStep,
  UnitsStep,
  SubunitsStep,
  CourseImageStep,
  ReviewStep,
} from '@/common/components/admin/modals/course-creator-steps';
import { CourseBuilderData } from 'course-types';

interface CourseWizardStepRenderMapProps {
  currentStep: number;
  courseData: CourseBuilderData;
  handleChange: (field: string, value: any, unitIndex?: number, subunitIndex?: number) => void;
  handleAddUnit: () => void;
  handleAddSubunit: (unitIndex: number) => void;
  handleRemoveUnit: (index: number) => void;
  handleRemoveSubunit: (unitIndex: number, subunitIndex: number) => void;
  handleSaveContent: (activityData: any, unitIndex: number, subunitIndex: number) => void;
  handleImageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

interface StepComponentInfo {
  component: React.ComponentType<any>;
  name: string;
}

interface StepMapType {
  [key: number]: StepComponentInfo;
}

const CourseWizardStepRenderMap = (props: CourseWizardStepRenderMapProps) => {
  const { currentStep, courseData, ...handlers } = props;

  switch (currentStep) {
    case 0:
      return <CourseNameStep courseName={courseData.name} onChange={handlers.handleChange} />;
    case 1:
      return (
        <UnitsStep
          units={courseData.units}
          onChange={handlers.handleChange}
          onAddUnit={handlers.handleAddUnit}
          onRemoveUnit={handlers.handleRemoveUnit}
        />
      );
    case 2:
      return (
        <SubunitsStep
          units={courseData.units}
          onChange={handlers.handleChange}
          onAddSubunit={handlers.handleAddSubunit}
          onRemoveSubunit={handlers.handleRemoveSubunit}
        />
      );
    case 3:
      // return <CourseImageStep onImageChange={handlers.handleImageChange} />;
      // case 4:
      return <ReviewStep courseData={courseData} onChange={handlers.handleChange} />;
    default:
      return null;
  }
};

const StepMap: StepMapType = {
  0: { component: CourseNameStep, name: 'Course Name' },
  1: { component: UnitsStep, name: 'Units' },
  2: { component: SubunitsStep, name: 'Subunits' },
  // 3: { component: CourseImageStep, name: 'Course Image' },
  3: { component: ReviewStep, name: 'Review & Submit' },
};

export { CourseWizardStepRenderMap, StepMap };
